import { useParams } from "react-router-dom";
import { Tab } from "@mui/material";
import { StyledPaper, Tabs, Title } from "../../../components";
import { usePrompt } from "../queries";
import { PageLoader } from "../../../components/molecules/PageLoader";
import { PATHS } from "../../../constants/paths";

export enum PromptTabs {
  PersonasTemplate = "personas_template",
  IntroductionPromptTemplate = "introduction_prompt_template",
  ProductsPromptTemplate = "products_prompt_template",
}

export const PromptTitles = {
  [PromptTabs.PersonasTemplate]: { label: "Personas Template" },
  [PromptTabs.IntroductionPromptTemplate]: {
    label: "Introduction Prompt Template",
  },
  [PromptTabs.ProductsPromptTemplate]: { label: "Products Prompt Template" },
};

const PromptDetails = () => {
  const params = useParams();
  const { promptId } = params;

  const { data, isLoading } = usePrompt(promptId!);

  if (isLoading) {
    return (
      <StyledPaper>
        <PageLoader />
      </StyledPaper>
    );
  }

  const customerName = data && !data.isDefault ? data.customer_name : "Default";

  return (
    <StyledPaper>
      <Title title={`Persona prompt: ${customerName}`} />
      <Tabs context={{ data, titles: PromptTitles }}>
        <Tab
          key={PromptTabs.PersonasTemplate}
          label="Personas Template"
          value={`${PATHS.Agents.Prompts.Path}/${promptId}/${PromptTabs.PersonasTemplate}`}
        />
        <Tab
          key={PromptTabs.IntroductionPromptTemplate}
          label="Introduction Prompt Template"
          value={`${PATHS.Agents.Prompts.Path}/${promptId}/${PromptTabs.IntroductionPromptTemplate}`}
        />
        <Tab
          key={PromptTabs.ProductsPromptTemplate}
          label="Products Prompt Template"
          value={`${PATHS.Agents.Prompts.Path}/${promptId}/${PromptTabs.ProductsPromptTemplate}`}
        />
      </Tabs>
    </StyledPaper>
  );
};

export default PromptDetails;
